import React from 'react';
import { Observer } from 'mobx-react';
import Column from '../../common/Column';
import DealCell from './DealCell';

const dealColumnsConfig = [
  {
    Header: 'DealId',
    accessor: 'DealId',
    Cell: DealCell,
    id: 1,
  },
];

const DealColumn = ({ dealsWithDealTransactions }) => {
  return (
    <Observer
      render={() => {
        return (
          <Column
            dataArray={dealsWithDealTransactions}
            config={dealColumnsConfig}
            title="Deals"
            style={{ width: '420px' }}
          />
        );
      }}
    />
  );
};

export default DealColumn;
